module.exports = __webpack_public_path__ + "static/media/sgd-17.bf6f270e.png";